import type { PlacementDataSource } from '~/api/data-source/placement';
import { placementDataSource } from '~/api/data-source/placement';
import type {
  PlacementBanner,
  PlacementNavigationBar,
  PlacementSearchKeyword,
  PlacementSearchTopBanner,
} from '~/api/model';
import {
  parseModelArray,
  placementBannerSchema,
  placementNavigationBarSchema,
  placementSearchKeywordSchema,
  placementSearchTopBannerSchema,
} from '~/api/model';

export interface PlacementRepository {
  getNavigationBars(businessId: number): Promise<PlacementNavigationBar[]>;
  getBanners(businessId: number, placement: string): Promise<PlacementBanner[]>;
  getSearchKeywords(
    businessId: number,
    placement: string,
  ): Promise<PlacementSearchKeyword[]>;
  getSearchTopBanners(businessId: number): Promise<PlacementSearchTopBanner[]>;
}

export class PlacementRepositoryImpl implements PlacementRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: PlacementDataSource = placementDataSource,
  ) {}

  async getNavigationBars(businessId: number) {
    const response = await this.dataSource.getNavigationBars(businessId);
    return parseModelArray(
      placementNavigationBarSchema,
      response,
      'PlacementNavigationBar',
    );
  }

  async getBanners(businessId: number, placement: string) {
    const response = await this.dataSource.getBanners(businessId, placement);
    return parseModelArray(placementBannerSchema, response, 'PlacementBanner');
  }

  async getSearchKeywords(businessId: number, placement: string) {
    const response = await this.dataSource.getSearchKeywords(
      businessId,
      placement,
    );
    return parseModelArray(
      placementSearchKeywordSchema,
      response,
      'PlacementSearchKeyword',
    );
  }

  async getSearchTopBanners(businessId: number) {
    const response = await this.dataSource.getSearchTopBanners(businessId);
    return parseModelArray(
      placementSearchTopBannerSchema,
      response,
      'PlacementSearchTopBanner',
    );
  }
}

export const placementRepository = new PlacementRepositoryImpl();
